const AcFormatErrorCode = error => {
  return error && error.response && error.response.status
    ? error.response.status
    : 'Netwerk Error';
};

export default AcFormatErrorCode;
